import Excel from 'exceljs';
import { error } from 'utils/alert';
import { downloadExcelFile } from 'utils/file';
import {
  ExhibitTemplateProps,
  ExhibitTemplates,
  getTemplateName,
} from './exhibitType';
import { templateAllowedClaims } from './templateAllowedClaims';
import { templateAlterClaimAmount } from './templateAlterClaimAmount';
import { templateAlterClaimAmountProposeDebtor } from './templateAlterClaimAmountProposeDebtor';
import { templateAlterDebtor } from './templateAlterDebtor';
import { templateExpungeNoSurviving } from './templateExpungeNoSurviving';
import { templateExpungeWithSurviving } from './templateExpungeWithSurviving';

export interface IExcelCreator {
  fileName: string;
  getWorkbook: (props: ExhibitTemplateProps) => Promise<Excel.Workbook | null>;
}

const ExcelCreatorTemplate: { [id in ExhibitTemplates]: IExcelCreator } = {
  [ExhibitTemplates.AllowedClaims]: templateAllowedClaims,
  [ExhibitTemplates.AlterClaimAmount]: templateAlterClaimAmount,
  [ExhibitTemplates.AlterClaimAmountProposeDebtor]:
    templateAlterClaimAmountProposeDebtor,
  [ExhibitTemplates.AlterDebtor]: templateAlterDebtor,
  [ExhibitTemplates.ExpungeNoSurviving]: templateExpungeNoSurviving,
  [ExhibitTemplates.ExpungeWithSurviving]: templateExpungeWithSurviving,
};

export const exportExhibitExcelFile = async (props: ExhibitTemplateProps) => {
  const { resolutionSubStatusId } = props.exhibit;

  const templateName = getTemplateName(resolutionSubStatusId);
  const template = ExcelCreatorTemplate[templateName!];
  if (!template) {
    error(`Can't create document for this resolution type`);
    return;
  }

  downloadExhibitTemplate(template, props);
};

const downloadExhibitTemplate = async (
  template: IExcelCreator,
  props: ExhibitTemplateProps,
) => {
  const workbook = await template.getWorkbook(props);
  if (!workbook) {
    error('XSLX file is empty');
    return;
  }

  await downloadExcelFile(workbook, template.fileName);
};
